<template>
  <CommonTable
    list-getter="projectAccountingStore/exportLinkStore/getList"
    delete-item-dispatch="projectAccountingStore/exportLinkStore/delete"
    update-item-dispatch="projectAccountingStore/exportLinkStore/update"
    create-item-dispatch="projectAccountingStore/exportLinkStore/create"
    :headers="headers"
    :slots="slots"
    :actions="actions"
    resource="export-links"
    can-delete
    can-edit
    can-add
    :static-dispatch-params="{
      project_id: $route.params.project_id,
      cost_centre_id: $route.params.id
    }"
    @updated="updateList"
  ></CommonTable>
</template>

<script>
import CommonTable from "../../../common/tables/CommonTable";
import { rules } from "../../../mixins/rules";

export default {
  name: "ListExportLink",
  components: {
    CommonTable
  },
  mixins: [rules],
  data: function() {
    return {
      actions: [],
      headers: [
        {
          text: this.$t("export-links.interface"),
          value: "interface",
          align: "left"
        },
        {
          text: this.$t("export-links.target-type"),
          value: "target_type"
        },
        {
          text: this.$t("export-links.target-id"),
          value: "target_id"
        },
        {
          text: this.$t("export-links.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      list: [],
      page: {}
    };
  },
  computed: {
    getParams() {
      return `${this.$route.query.page}
              ${this.$route.query.limit_items}
              ${this.$route.query.orders}
              `;
    },
    types() {
      return this.$store.getters[
        "projectAccountingStore/exportLinkTypeStore/getList"
      ].map(i => ({ value: i.id, text: i.interface + " > " + i.target_name }));
    },
    slots() {
      let types = this.types;
      let rules = this.rules;
      return [
        {
          name: "target_id",
          title: "target-id",
          type: "text",
          form: {
            type: "text",
            rules: [rules.required],
            visible: true
          }
        },
        {
          name: "interface",
          type: "text",
          form: {
            type: "select",
            name: "target_type_id",
            items: types,
            rules: [rules.required],
            visible: true
          }
        }
      ];
    }
  },
  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      let params = this.formingParams();
      this.$store.dispatch("projectAccountingStore/exportLinkStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        project_id: this.$route.params.project_id,
        limit: -1,
        filters: {
          cost_centre: this.$route.params.id
        }
      };
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("projectAccountingStore/exportLinkTypeStore/getList", {
      params: { limit: -1 }
    });
  }
};
</script>

<style scoped></style>
